var map = {
	"./checkmark.svg": "6891",
	"./chevron_left.svg": "879c",
	"./chevron_right.svg": "0823",
	"./close.svg": "0572",
	"./error.svg": "7ea5",
	"./expand_more.svg": "a91b",
	"./facebook.svg": "8b07",
	"./favorite.svg": "fe50",
	"./icon_collect.svg": "92b4",
	"./instagram.svg": "07fb",
	"./linkedin.svg": "277b",
	"./mail.svg": "e28e",
	"./report.svg": "a7b3",
	"./search.svg": "f919",
	"./twitter.svg": "974d",
	"./whatsapp.svg": "bdf8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";